import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[qmBlock]',
  standalone: true,
})
export class QMBlockDirective implements OnInit {
  constructor(
    private readonly renderer: Renderer2,
    private readonly hostElement: ElementRef
  ) {}

  ngOnInit() {
    this.renderer.setAttribute(this.hostElement.nativeElement, 'data-qm-block', 'true');
  }
}

@Directive({
  selector: '[qmEncrypt]',
  standalone: true,
})
export class QMEncryptDirective implements OnInit {
  constructor(
    private readonly renderer: Renderer2,
    private readonly hostElement: ElementRef
  ) {}

  ngOnInit(): void {
    this.renderer.setAttribute(this.hostElement.nativeElement, 'data-qm-encrypt', 'true');
  }
}
